<script>
  import CATEGORY_MAP from "../categories";
  import { scaleLinear } from "d3-scale";
  import SvgArrow from "./SvgArrow.svelte";
  import Tooltip from "./Tooltip.svelte";

  export let stats;
  export let no2cat;

  const BIN_COUNT = CATEGORY_MAP.length;
  let bins, maxBinValue, yScale, heightScale, widthScale, columnWidth, barWidth, yTicks;
  let tooltipX, tooltipY, tooltipBin;
  $: no2catIndex = CATEGORY_MAP.findIndex((cat) => cat.category === no2cat);

  $: {
    bins = [];
    for (const category of CATEGORY_MAP) {
      const count = stats.counts[category.category];
      bins.push({ ...category, count });
    }
    maxBinValue = Math.max(...bins.map((bin) => bin.count));
    yScale = scaleLinear().domain([0, maxBinValue]).range([100, 0]);
    heightScale = scaleLinear().domain([0, maxBinValue]).range([0, 100]);
    widthScale = scaleLinear().domain([0, BIN_COUNT]).range([0, 100]);
    columnWidth = widthScale(1);
    barWidth = widthScale(0.95);
    yTicks = heightScale.ticks(4); // ticks(0, binDomains[1], 4);
  }

  const showTooltip = (binIndex) => {
    tooltipX = widthScale(binIndex) + columnWidth / 2;
    tooltipY = yScale(bins[binIndex].count);
    tooltipBin = bins[binIndex];
  };

  const hideTooltip = () => {
    tooltipBin = undefined;
  };

  // const activeX = widthScale(activeBinIndex) + columnWidth / 2;
</script>

<div class="chart">
  <div class="inner">
    <svg class="bars" viewBox="0 0 100 100" preserveAspectRatio="none">
      <g transform="translate(0 0)">
        <!-- <line x0="0" x1="300" y1="100" y2="100" stroke="#ededed" />
        <line x0="0" x1="0" y1="0" y2="100" stroke="#ededed" /> -->
        <!-- {#each yTicks as tick, i}
          <g key={i}>
            <line x1="0" x2="300" y1={100 - heightScale(tick)} y2={100 - heightScale(tick)} stroke="#ededed" />
            <text x="-10" y={100 - heightScale(tick) + 4} fill="#000" text-anchor="end" fontSize={11} class="font-sans">{tick}</text>
          </g>
        {/each} -->
        {#each bins as bin, i}
          <g key={i}>
            <rect
              class="pointer-events-none"
              x={widthScale(i) + columnWidth / 2 - barWidth / 2}
              y={yScale(bin.count)}
              width={barWidth}
              height={heightScale(bin.count)}
              fill={bin.color}
            />
            <rect
              x={widthScale(i) + columnWidth / 2 - barWidth / 2 - 1}
              y="0"
              width={barWidth + 2}
              height={100}
              fill="transparent"
              on:mouseenter={() => showTooltip(i)}
              on:mouseleave={hideTooltip}
            />
          </g>
        {/each}

        <!-- <SvgArrow x={widthScale(no2catIndex) + columnWidth / 2} y={87 - heightScale(bins[no2catIndex].count)} direction="down" color="#000" /> -->
      </g>
    </svg>
    {#each yTicks as tick, i}
      <div class="axis-left" style="top: {yScale(tick)}%"><span class="count-label">{tick}</span></div>
    {/each}
    {#each bins as bin, i}
      <div class="axis-bottom" style="left: {widthScale(i)}%;" fill="black">
        {i !== bins.length - 1 ? `${bin.min}-${bin.max}` : "50+"}
      </div>
    {/each}

    {#if tooltipBin}
      <Tooltip x={tooltipX} y={tooltipY} bin={tooltipBin} />
    {/if}

    <svg
      class="arrow"
      viewBox="0 0 10 10"
      style="left:{widthScale(no2catIndex) + columnWidth / 2}%; bottom:{heightScale(bins[no2catIndex].count) * 1.7}"
    >
      <path d="M-7,0 L7,0 L0,9 Z" fill="#666" />
    </svg>
  </div>
  <p class="unit">µg/m<sup style="font-size: 0.6em">3</sup></p>
</div>

<style>
  .chart {
    position: relative;
    height: 200px;
    padding: 8px 0 24px 1em;
    width: 100%;
  }

  .inner {
    height: 100%;
    display: block;
    position: relative;
  }

  svg.bars {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: visible;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  svg.arrow {
    position: absolute;
    width: 12px;
    height: 12px;
    overflow: visible;
  }

  .axis-left {
    position: absolute;
    left: -4px;
    pointer-events: none;
    text-align: right;
    font-size: 0.8rem;
    font-family: sans-serif;
  }

  .count-label {
    position: absolute;
    right: 0;
    bottom: 2px;
    color: #999;
  }

  .axis-bottom {
    position: absolute;
    bottom: -15px;
    text-align: right;
    font-size: 0.8rem;
    font-family: sans-serif;
    pointer-events: none;
    transform: translate(-23px, 0) rotate(-55deg);
    transform-origin: right center;
    color: #999;
    width: 40px;
  }

  .unit {
    position: absolute;
    bottom: -46px;
    width: 100%;
    font-size: 12px;
    text-align: center;
    color: #999;
  }
</style>
